import { t } from "@/shared/i18n/locale";
import type { ApiResponse } from "@/shared/types/api";

export class ApiError extends Error {
  status: number;
  code?: string;

  constructor(message: string, status: number, code?: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export async function apiRequest<T>(path: string, init?: RequestInit): Promise<T> {
  const isFormData = init?.body instanceof FormData;

  const response = await fetch(path, {
    ...init,
    credentials: "include",
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(init?.headers ?? {}),
    },
  });

  const payload = (await response.json().catch(() => null)) as ApiResponse<T> | null;

  if (!response.ok || !payload || !payload.success) {
    const message = payload && !payload.success
      ? payload.error?.message ?? payload.message ?? "Erro na requisicao"
      : "Erro na requisicao";
    const code = payload && !payload.success ? payload.error?.code : undefined;
    throw new ApiError(t(message), response.status, code);
  }

  return payload.data;
}
